import React from "react";
import { Box } from "@mui/material";
import { FeeNoteColumns } from "../../../data/DynamicTable/Collumns";
import { allFeeNotesView } from "../../../data/Axios/queries";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { accountsmanagement } from "../../../config";
import { useState } from "react";
import FeeNoteDetailDialog from "./FeeNoteDetailDialog";
import FeeNoteForm from "./form";

const base_url = accountsmanagement.uri;

const FeeNotesPendingApproval = () => {
  const [openFeeNoteDialog, setOpenFeeNoteDialog] = useState(false);
  const [selectedFeeNote, setSelectedFeeNote] = useState(null);
  const [refreshTable, setRefreshTable] = useState(null);

  const actions = {
    entity: "FeeNotes Pending Approval",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    ViewFeeNoteLines: {
      key: "VIEWFEENOTELINES",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row, refresh) => {
        setRefreshTable(() => refresh);
        setSelectedFeeNote(row);
        setOpenFeeNoteDialog(true);
      },
    },
    PrintFeeNote: {
      key: "PRINTFEENOTE",
      button_name: "Print",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    approveFeeNote: {
      key: "APPROVEFEENOTE",
      button_name: "Approve",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    showStatus: true,
    modelName: "allPendingApprovalFeenotes",
    dataObject: {
      inputFields: {
        documentTypeId: 3,
      },
      inputObjectName: "allPendingApprovalFeenotes",
      inputSubObjectName: "parameters",
      returnFields: [
        "id",
        "issueDate",
        "documentTypeId",
        "documentTypeName",
        "clientTypeId",
        "clientId",
        "clientName",
        "caseId",
        "caseNumber",
        "caseTitle",
        "caseDescription",
        "caseSummary",
        "caseCategoryId",
        "caseCategory",
        "caseSubcategoryId",
        "caseSubcategory",
        "caseStatus",
        "assignedTo",
        "dateOpened",
        "dateClosed",
        "priority",
        "amount",
        "statusId",
        "statusName",
        "dueDate",
        "currencyId",
        "exchangeRate",
        "companyId",
        "company",
        "proformaFeeNoteQuotationId",
        "withholdingTaxId",
        "withholdingTaxAmount",
        "isActive",
        "createdBy",
        "createdDate",
        "updatedBy",
        "updatedDate",
        "balance",
      ],
    },
  };

  return (
    <Box m="10px">
      <DynamicTable
        title="Fee Note Pending Approval"
        subtitle="Fee Note Pending Approval List"
        columns={FeeNoteColumns}
        FormComponent={FeeNoteForm}
        base_url={base_url}
        actions={actions}
      />

      {openFeeNoteDialog && (
        <FeeNoteDetailDialog
          open={openFeeNoteDialog}
          onClose={() => {
            setOpenFeeNoteDialog(false);
            if (refreshTable) refreshTable();
          }}
          feeNoteData={selectedFeeNote}
          refetchData={() => {
            if (refreshTable) refreshTable();
          }}
        />
      )}
    </Box>
  );
};

export default FeeNotesPendingApproval;
